import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { makeStyles, createStyles } from '@mui/styles';
//import styles from "assets/jss/components/missedCallsStyle";

import { firestore_users_Actions } from 'store/profile/actions';

import Moment from "devtools/momentjs";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

import { VerticalBarChart, HorizontalBarChart } from 'components/Charts/MissedCalls';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

const YesterdayCharts = ({ unhandledCalls, handledCalls, loading, users, filters: filterProp, ...props}) => {
  const classes = useStyles();
  const [filters, setFilters] = useState(filterProp);

  useEffect(() => {
    if(filterProp !== filters) setFilters(filterProp);
  }, [filterProp]);

  const labelsHourly = Moment.hoursAsLabels('HH');
  const startOfDay = Moment.command(moment => moment().subtract(1, 'days').startOf('day'));
  const endOfDay = Moment.command(moment => moment().subtract(1, 'days').endOf('day'));
  const unhandledDataset = unhandledCalls.filter(call => Moment.command(moment => moment(call?.aika, "DD-MM-YYYY HH:mm:ss").isBetween( startOfDay, endOfDay )))
  const handledDataset = handledCalls.filter(call => {
    return Moment.command(moment => moment(call?.aika, "DD-MM-YYYY HH:mm:ss").isBetween( startOfDay, endOfDay )) && Moment.command(moment => moment(call?.handledtime, "DD-MM-YYYY HH:mm:ss").isBetween( startOfDay, endOfDay )) && true;
  });

  return (
    <GridContainer justifyContent={filters.gridLayout > 6 ? 'center' : 'flex-start'}>
      {
        filters.view === 'Hourly View' || filters.view === 'All Charts'
        ? <GridItem xs={filters.gridLayout}>
            <VerticalBarChart
              footerText='All Calls'
              customLabels={labelsHourly}
              title='All Calls for Yesterday Hourly'
              color='info'
              selectedDatasets={filters.selectedDatasets}
              subLabels={{
                x: 'Hour',
                y: 'Count'
              }}
              data={[...unhandledDataset, ...handledDataset ]}
              loading={loading}
              filterCallback={(item, dataset, increment) => {
                if(item?.aika) {
                  const index = Moment.command(moment => moment(item.aika, "DD-MM-YYYY HH:mm:ss").format('HH'));
                  increment(index)
                }
                return;
              }}
            />
          </GridItem>
        : null
      }

      {
        filters.view === 'Hourly View' || filters.view === 'All Charts'
        ? <GridItem xs={filters.gridLayout}>
            <VerticalBarChart
              footerText='Missed Calls'
              customLabels={labelsHourly}
              title='Missed Calls for Yesterday Hourly'
              color='danger'
              selectedDatasets={filters.selectedDatasets}
              subLabels={{
                x: 'Hour',
                y: 'Count'
              }}
              data={unhandledDataset}
              loading={loading}
              filterCallback={(item, dataset, increment) => {
                if(item?.aika) {
                  const index = Moment.command(moment => moment(item.aika, "DD-MM-YYYY HH:mm:ss").format('HH'));
                  increment(index)
                }
                return;
              }}
            />
          </GridItem>
        : null
      }

      {
        filters.view === 'Hourly View' || filters.view === 'All Charts'
        ? <GridItem xs={filters.gridLayout}>
            <VerticalBarChart
              footerText='Handled Calls'
              customLabels={labelsHourly}
              title='Handled Calls for Yesterday Hourly'
              color='success'
              selectedDatasets={filters.selectedDatasets}
              subLabels={{
                x: 'Hour',
                y: 'Count'
              }}
              data={handledDataset}
              loading={loading}
              filterCallback={(item, dataset, increment) => {
                if(item?.handledtime) {
                  const index = Moment.command(moment => moment(item.handledtime, "DD-MM-YYYY HH:mm:ss").format('HH'));
                  increment(index)
                }
                return;
              }}
            />
          </GridItem>
        : null
      }

      {
        filters.view === 'Daily View' || filters.view === 'All Charts'
        ? <GridItem xs={filters.gridLayout}>
            <VerticalBarChart
              footerText='Missed Calls'
              customLabels={Moment.chartLabels([0, 'days'], 'MMM[,] DD dd')}
              title='Missed Calls For Yesterday'
              color='danger'
              selectedDatasets={filters.selectedDatasets}
              subLabels={{
                x: 'Date',
                y: 'Count'
              }}
              data={unhandledDataset}
              loading={loading}
              filterCallback={(item, dataset, increment) => {
                if(item?.handledtime) {
                  const index = Moment.command(moment => moment(item.handledtime, "DD-MM-YYYY HH:mm:ss").format('MMM[,] DD dd'));
                  increment(index)
                }
                return;
              }}
            />
          </GridItem>
        : null
      }

      {
        filters.view === 'Daily View' || filters.view === 'All Charts'
        ? <GridItem xs={filters.gridLayout}>
            <VerticalBarChart
              footerText='Handled Calls'
              customLabels={Moment.chartLabels([0, 'days'], 'MMM[,] DD dd')}
              title='Handled Calls For Yesterday'
              color='success'
              selectedDatasets={filters.selectedDatasets}
              subLabels={{
                x: 'Date',
                y: 'Count'
              }}
              data={handledDataset}
              loading={loading}
              filterCallback={(item, dataset, increment) => {
                if(item?.handledtime) {
                  const index = Moment.command(moment => moment(item.handledtime, "DD-MM-YYYY HH:mm:ss").format('MMM[,] DD dd'));
                  increment(index)
                }
                return;
              }}
            />
          </GridItem>
        : null
      }

      {
        filters.view === 'Handled By' || filters.view === 'All Charts'
        ? <GridItem xs={filters.gridLayout}>
            <HorizontalBarChart
              footerText='Handled Calls'
              title='Total Count of Handled Calls For Yesterday'
              color='success'
              subLabels={{
                x: 'Count',
                y: 'Person'
              }}
              data={handledDataset}
              loading={loading}
              filterCallback={(item, dataset, increment) => {
                if(item.handled === 1 && item.handledperson) {
                  increment(item.handledperson)
                }
                return;
              }}
            />
          </GridItem>
        : null
      }
    </GridContainer>
  );
}


export default YesterdayCharts;
